import { SearchRegion } from '../../apis/region/SearchRegion';

export const RegionService = {
  searchByCity: async (cityId: number) => {
    return await SearchRegion(cityId);
  },
};
